module.exports = __webpack_public_path__ + "img/LREXDinoFooter.deb4ad0f.jpg";